import { size } from '@hubble/tokens/web';

function getSize(size$1) {
  return size.icon[size$1];
}

export { getSize };
